// src/hooks/queries/query-keys.ts

export const queryKeys = {
  user: {
    session: () => ["user", "session"] as const,
    meta: () => ["user", "meta"] as const,
  },
  wallets: {
    addresses: () => ["wallets", "addresses"] as const,
  },
  orders: {
    all: () => ["orders"] as const,
    list: (params: { status?: string; apiUrl?: string }) =>
      ["orders", "list", params] as const,
    detail: (id: string) => ["orders", "detail", id] as const,
    fiatDetail: (key: string) => ["orders", "fiat-detail", key] as const,
    fraudSignals: (key: string) => ["orders", "fraud-signals", key] as const,
  },
  compliance: {
    kyc: () => ["compliance", "kyc"] as const,
    kyb: () => ["compliance", "kyb"] as const,
  },
  fees: {
    estimate: (params: { chain: string; asset: string; amount: string }) =>
      ["fees", "estimate", params] as const,
  },
  settings: {
    webhooks: () => ["settings", "webhooks"] as const,
    apiKey: () => ["settings", "apiKey"] as const,
    ramping: () => ["settings", "ramping"] as const,
    fiatIntegrations: () => ["settings", "fiatIntegrations"] as const,
    payoutWallet: () => ["settings", "payoutWallet"] as const,
  },
  reports: {
    orders: (params: { from?: string; to?: string; status?: string; include?: string }) =>
      ["reports", "orders", params] as const,
  },
  twoFactor: {
    devices: () => ["twoFactor", "devices"] as const,
  },
  ramping: {
    countries: () => ["ramping", "countries"] as const,
    country: (pk?: string) => ["ramping", "country", pk] as const,
    provider: (params: Record<string, unknown>) =>
      ["ramping", "provider", params] as const,
    quotes: (params: Record<string, unknown>) =>
      ["ramping", "quotes", params] as const,
    fiats: (params?: Record<string, unknown>) =>
      ["ramping", "fiats", params] as const,
    crypto: (params?: Record<string, unknown>) =>
      ["ramping", "crypto", params] as const,
    paymentMethods: (params?: Record<string, unknown>) =>
      ["ramping", "paymentMethods", params] as const,
    kyrrexCountryId: (iso2: string, pk?: string) =>
      ["ramping", "kyrrexCountryId", iso2, pk] as const,
    kyrrexFees: (params: Record<string, unknown>) =>
      ["ramping", "kyrrexFees", params] as const,
  },
  dashboard: {
    summary: (preset: string, dateFrom?: string, dateTo?: string) =>
      ["dashboard", "summary", preset, dateFrom, dateTo] as const,
    timeseries: (preset: string, dateFrom?: string, dateTo?: string) =>
      ["dashboard", "timeseries", preset, dateFrom, dateTo] as const,
    geo: (preset: string, dateFrom?: string, dateTo?: string) =>
      ["dashboard", "geo", preset, dateFrom, dateTo] as const,
    geoDetail: (countryCode: string, preset: string, dateFrom?: string, dateTo?: string) =>
      ["dashboard", "geoDetail", countryCode, preset, dateFrom, dateTo] as const,
  },
  merchants: {
    list: () => ["merchants"] as const,
  },
  invoices: {
    all: () => ["invoices"] as const,
  },
  withdrawals: {
    list: (params?: { chain?: string; asset?: string }) =>
      ["withdrawals", "list", params] as const,
  },
  upcomingPayouts: {
    list: () => ["upcomingPayouts", "list"] as const,
  },
  withdrawalWallets: {
    list: (params?: { chain?: string; asset?: string }) =>
      ["withdrawalWallets", "list", params] as const,
  },
  offrampCard: {
    cardTypes: () => ["offrampCard", "cardTypes"] as const,
    cards: () => ["offrampCard", "cards"] as const,
    balance: () => ["offrampCard", "balance"] as const,
    card: (id: string) => ["offrampCard", "card", id] as const,
    sensitive: (id: string) => ["offrampCard", "sensitive", id] as const,
    wallet: () => ["offrampCard", "wallet"] as const,
    transactions: (params?: Record<string, unknown>) =>
      ["offrampCard", "transactions", params] as const,
    topUpQuote: (amount: number) =>
      ["offrampCard", "topUpQuote", amount] as const,
  },
  cardActivationRequest: {
    current: () => ["cardActivationRequest", "current"] as const,
    reusableDocument: () => ["cardActivationRequest", "reusableDocument"] as const,
    reusablePersonalData: () => ["cardActivationRequest", "reusablePersonalData"] as const,
    payment: () => ["cardActivationRequest", "payment"] as const,
  },
} as const;
